import $ from 'jquery';

window.$ = window.jQuery = $;
window.$ = window.jQuery = $.noConflict();

let loaded = false;
export default class BviTool {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            if ('Bvi' in window) {
                new Bvi();
            } else {
                $('.bvi-open').click(function (e) {
                    e.preventDefault();
                    if (loaded) {
                        return false;
                    }

                    loaded = true;
                    BX.Runtime.loadExtension('bges.bvi')
                        .then(() => {
                            new Bvi();
                            setTimeout(() => {
                                e.target.click();
                            });
                        });
                });
            }
        });
    }
}